import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import { FIELD_ID_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { ManageRolesFormType } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Id } from "PFCore/types";

// Narrow empty check — does not treat 0 or false as empty, so valid numeric values like
// min_required_count = 0 are not incorrectly rejected.
export const isEmptyValue = (value: unknown): boolean =>
  isNil(value) ||
  (typeof value === "string" && value.trim() === "") ||
  (Array.isArray(value) && isEmpty(value));

type RoleFieldChange = {
  roleId: Id;
  fieldName: string;
  nextValue: unknown;
  prevValue: unknown;
};

export const diffRoles = (
  prev: ManageRolesFormType[],
  next: ManageRolesFormType[],
  trackedKeys: Set<string>
): RoleFieldChange[] => {
  const prevById = new Map<Id, ManageRolesFormType>(
    prev.filter((role) => role?.[FIELD_ID_KEY]).map((role) => [role[FIELD_ID_KEY]!, role])
  );

  const changes: RoleFieldChange[] = [];
  next.forEach((role) => {
    const roleId = role?.[FIELD_ID_KEY];

    if (!roleId) {
      return;
    }

    const prevRole = prevById.get(roleId);

    if (!prevRole) {
      return;
    }

    trackedKeys.forEach((fieldName) => {
      const nextValue = get(role, fieldName);
      const prevValue = get(prevRole, fieldName);

      if (!isEqual(nextValue, prevValue)) {
        changes.push({ roleId, fieldName, nextValue, prevValue });
      }
    });
  });

  return changes;
};
